const Mission = props => {
    return <div className="mission">
        <div className="content">
            <div className="wrapper">
                <div className="inner">
                    <div className="item">
                        <h2>我们的愿景</h2>
                        <div className="desc">
                            成为人工智能与医疗健康融合创新的全球领导者，用科技赋能人类健康生活。
                        </div>
                    </div>
                    <div className="item">
                        <h2>我们的使命</h2>
                        <div className="desc">
                            通过人工智能技术创新，构建智能医疗生态系统，为医疗机构、患者和健康人群提供全方位的数字化解决方案。
                        </div>
                    </div>
                    <div className="item">
                        <h2>我们的核心价值观</h2>
                        <div className="desc align-left">
                            <b>‌创新驱动‌：</b>
                            <span>持续投入AI基础研究和应用开发，保持技术领先优势</span>
                        </div>
                        <div className="desc align-left">
                            <b>‌客户至上‌‌：</b>
                            <span>以解决医疗健康领域的实际痛点为出发点</span>
                        </div>
                        <div className="desc align-left">
                            <b>协同共赢‌：</b>
                            <span>建立开放的技术平台，促进产学研医多方合作</span>
                        </div>
                        <div className="desc align-left">
                            <b>‌责任担当‌‌：</b>
                            <span>严格遵守医疗伦理，确保技术应用的合规性和安全性</span>
                        </div>
                        <div className="desc align-left">
                            <b>‌追求卓越‌‌：</b>
                            <span>在产品质量和服务体验上精益求精</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


}

export default Mission  
